import { useMemo } from 'react';

import { REMAINDER_TRUST_COPY_MAP } from '@/modules/entities/gratTrusts/GratBeneficiaryTree/TrustLeaf';
import { getAssetLocationDisplay } from '@/modules/entities/utils/getAssetLocationDisplay';
import { ContextPrimaryClient } from '@/modules/household/contexts/householdDetails.context';
import {
  EntityGstStatus,
  EntityInEstateStatus,
  TrustTaxStatus,
} from '@/types/schema';

interface Props {
  primaryClients: ContextPrimaryClient[];
  inEstateStatus?: EntityInEstateStatus | null;
  gstStatus: EntityGstStatus | null;
  stateInEstateStatus?: EntityInEstateStatus | null;
}

export function getTestamentaryEntitySummaryData({
  primaryClients,
  inEstateStatus,
  gstStatus,
  stateInEstateStatus,
}: Props) {
  const hasAliveSpouse = !!(primaryClients.length >= 2);

  const taxStatus = REMAINDER_TRUST_COPY_MAP[TrustTaxStatus.NonGrantorTrust];

  const assetLocation = getAssetLocationDisplay({
    inEstateStatus,
    stateInEstateStatus,
    gstStatus,
  }).locationDisplay;

  return {
    hasAliveSpouse,
    taxStatus,
    assetLocation,
  };
}

export function useTestamentaryEntitySummaryData({
  primaryClients,
  inEstateStatus,
  gstStatus,
  stateInEstateStatus,
}: Props) {
  return useMemo(
    () =>
      getTestamentaryEntitySummaryData({
        primaryClients,
        inEstateStatus,
        gstStatus,
        stateInEstateStatus,
      }),
    [primaryClients, inEstateStatus, gstStatus, stateInEstateStatus]
  );
}
